export enum OperationType {
    Cash = 1,
    NonCash = 2,
    System = 3,
    Claim = 4,
}

export const enumLabel = (value: OperationType) => {
    switch (value) {
        case OperationType.Cash:
            return 'Наличный';
        case OperationType.NonCash:
            return 'Безналичный';
        case OperationType.System:
            return 'Системный';
        case OperationType.Claim:
            return 'Претензия';

        default:
            return '';
    }
};
